import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Privacidade from "@/pages/Privacidade";

export const Route = createFileRoute("/privacidade")({
  head: () => buildHead({
    title: "Política de Privacidade | OP2P CRM e Agentes de IA",
    description: "Como a OP2P coleta, usa e protege os dados pessoais de clientes e visitantes, com transparência e segurança da informação.",
    path: "/privacidade",
  }),
  component: Privacidade,
});
